export const ONBOARDING_RENDER_TYPE_GENERAL = 'general';
export const ONBOARDING_RENTER_TYPE_VIDEO = 'video';
